var Backbone = require('backbone');


/**
 * TODO: if we only apply this document wide, do so at the state level -- or maybe have a doc model UI
 * BOX_PX_ADJUSTMENT:
 * - now 8 ( we want larger ); 8 for 8x8 coordinates that are used to jpg compression to prevent
 *   potential issue with artifacts ( though now John says to not worry about that ).
 *   - To avoid covering document with large padding, we don't allow it to extend to the adjacent lines and words.
 * - Now the same for lines, zones, and words -- may later want to break apart and have different values.
 * - Later phase this will likely be configurable.
 * Font:
 *  - show or hide may also want to be configurable, so that would be a setting
 *  - others sue when testing: 'Times New Roman', 'Courier New', Courier, monospace;
 *  - really the CSS font family
 */



module.exports = Backbone.Model.extend({


    defaults: {
        font: 'Arial, Helvetica, sans-serif',
        BOX_PX_ADJUSTMENT: 8
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/pgPositionalTextModel/uiModel.js
 ** module id = 346
 ** module chunks = 0
 **/